<div matDialogTitle>Cannot Remove Field</div>

<mat-dialog-content>
  <div class="modal-text">This option cannot be removed because it is currently associated with one or more Assets in the following locations:</div>
  @for (message of messageList; track message) {
    <ul class="modal-text">
      <li>{{message}}</li>
    </ul>
  }
</mat-dialog-content>
<div class="flex justify-flex-end gap-20">
  <button mat-raised-button [mat-dialog-close]="true" >Close</button>
</div>
